import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

// Envia pro nosso próprio backend (REACT_APP_RECARGA_API_URL), que repassa pro GlitchTip.
// Sem isso, o browser tentaria falar direto com o domínio do GlitchTip — e a rede da operadora
// só libera domínios cadastrados, então o evento nunca sairia do device do cliente.
export const initMonitoring = () => {
  if (process.env.REACT_APP_GLITCHTIP_ENABLED !== "true") return;

  Sentry.init({
    dsn: process.env.REACT_APP_GLITCHTIP_DSN,
    tunnel: `${process.env.REACT_APP_RECARGA_API_URL}/monitoring/envelope`,
    environment: process.env.REACT_APP_NODE_ENV,
    release: process.env.REACT_APP_VERSION,
    tracesSampleRate: parseFloat(process.env.REACT_APP_TRACES_SAMPLE_RATE || "0"),
    autoSessionTracking: false, // GlitchTip não suporta session tracking
    integrations: [new Integrations.BrowserTracing()],
  });
};

// Marca qual msisdn (número de telefone) do usuário está usando o app.
// Chamado via store.subscribe no index.js quando o targetMsisdn muda.
export const setSentryMsisdn = (msisdn) => {
  if (process.env.REACT_APP_GLITCHTIP_ENABLED !== "true") return;
  // @sentry/browser v6 não tem removeTag (adicionado em v7).
  // setTag com undefined remove efetivamente a tag do escopo.
  Sentry.setTag("msisdn", msisdn || undefined);
};
